import { Checkbox, FormControl, FormControlLabel, FormHelperText, Switch } from '@mui/material';
import type { ReactElement } from 'react';
import type { FieldComponentProps, FieldTypeSpec, ResolvedField } from '../types';

function Toggle({ field, error, control }: { field: ResolvedField<unknown>; error?: string; control: ReactElement }) {
  return (
    <FormControl error={!!error} disabled={field.disabled} className={field.className} sx={field.sx}>
      <FormControlLabel control={control} label={field.label} />
      {(error ?? field.helperText) && <FormHelperText sx={{ mt: -0.5 }}>{error ?? field.helperText}</FormHelperText>}
    </FormControl>
  );
}

export function SwitchInput({ field, value, onChange, error }: FieldComponentProps<boolean | null>) {
  return <Toggle field={field} error={error} control={
    <Switch size={field.size} checked={!!value} disabled={field.disabled} inputProps={field.attrs}
            onChange={(e) => onChange(e.target.checked)} {...field.props} />} />;
}

export function CheckboxInput({ field, value, onChange, error }: FieldComponentProps<boolean | null>) {
  return <Toggle field={field} error={error} control={
    <Checkbox size={field.size} checked={!!value} disabled={field.disabled} inputProps={field.attrs}
              onChange={(e) => onChange(e.target.checked)} {...field.props} />} />;
}

const yesNo = (v: unknown) => (v ? 'Yes' : 'No');

export const toggleTypes: Record<string, FieldTypeSpec> = {
  switch: { component: SwitchInput, display: yesNo },
  checkbox: { component: CheckboxInput, display: yesNo },
};
